import { AxiosResponse } from 'axios';
import { useQuery, UseQueryResult } from 'react-query';
import { WorkoutTemplateRetrieve } from 'types';
import { client } from 'utils/api-client';

function useWorkoutTemplate(
  workoutTemplateId: string | undefined,
): UseQueryResult<AxiosResponse<WorkoutTemplateRetrieve>> {
  return useQuery(
    ['workoutTemplate', workoutTemplateId],
    () => client.get<WorkoutTemplateRetrieve>(`workout-templates/${workoutTemplateId}/`),
    { enabled: !!workoutTemplateId },
  );
}

export default useWorkoutTemplate;
